import { Stack, Image, ImageFit, Label, PrimaryButton, DefaultButton, FontIcon, ComboBox, IconButton, IComboBoxOption, TextField, IComboBox, Spinner, SpinnerSize } from '@fluentui/react';
import React, { useRef } from 'react';
import styles from '../styles/pokemon.module.scss';
import { TProduct } from '../constants/types';

export interface IProductsProps {
    product: TProduct;
    onBuyClick?: Function;
    satprice?: number;
    onImageClick: Function;
    animationsEnabled: boolean;
    eurprice?: number;
    hideSwipe: boolean;
    reload?: Function;
    addCard?: Function;
    removeCard?: Function;
    saving: boolean;
    selectedSite: string;
    dev: boolean;
    viewer?: boolean;
    apiUrl: string;
    token: string;
    username: string;
    site: string;
    setMessage: Function;
    setError: Function;
    commission: number;
}

export interface IProductsState {
    selectedImageIdex: number;
    rarityStyle: string;
    rarityImgStyle: string;
    rarityImg: string;
    added: boolean;
    notAdded: boolean;
    startSwipe: number;
    endSwipe: number;
    swipeHidden: boolean;
    selectedImg: string;
    imgOptions: IComboBoxOption[];
    tagOptions: IComboBoxOption[];
    inputRef: any;
    tagRef: any;
    selectedTagValue: string;
    newTitle: string;
    newCost: number;
    newTags: string;
    selectedTagName: string;
    newTagName: string;
    newTagValue: string;
    loading: boolean;
    newDescription: string;
    newAvailable: number;
};

export default class ProductsComponent extends React.Component<IProductsProps, IProductsState> {
    constructor(props: IProductsProps) {
        super(props);
        
        this.swipeTimeout = this.swipeTimeout.bind(this);
        this.deleteImg = this.deleteImg.bind(this);
        this.onNewImgSelected = this.onNewImgSelected.bind(this);
        this.canSave = this.canSave.bind(this);
        this.onTagValueChange = this.onTagValueChange.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.calculatePrice = this.calculatePrice.bind(this);
        this.calculatePriceWithoutCommission = this.calculatePriceWithoutCommission.bind(this);

        let imgOptions: IComboBoxOption[] = [];
        let i=0;
        
        props.product.imageNames?.split(',').forEach(imageName => {
            if (imageName) {
                imgOptions.push({key: i, text: imageName});
                i++;
            }
        });

        //console.log({p: props.product});

        let tagOptions: IComboBoxOption[] = [];
        props.product.tags?.split('|').forEach(tag => {
            const tagparts = tag.split("$:$");
            tagOptions.push({key: tagparts[0], text: tagparts[0], data: tagparts[1]});
        });

        this.state = {
            imgOptions:imgOptions,
            selectedImg:props.product.imageNames?.length ? props.product.imageNames[0] : "",
            rarityStyle: "",
            rarityImgStyle: "",
            selectedImageIdex: 0,
            rarityImg: "",
            added: false,
            notAdded: false,
            startSwipe: -1,
            endSwipe: -1,
            swipeHidden: this.props.hideSwipe,
            inputRef: React.createRef(),
            tagRef: React.createRef(),
            tagOptions: tagOptions,
            selectedTagValue: "",
            newTitle: props.product.title,
            newCost: this.calculatePriceWithoutCommission(props.product.priceInEUR),
            newTags: props.product.tags,
            newDescription: props.product.description,
            selectedTagName: "",
            newTagName: "",
            newTagValue: "",
            loading: false,
            newAvailable: props.product.available
        };
    }

    componentDidUpdate(prevProps: Readonly<IProductsProps>, prevState: Readonly<IProductsState>, snapshot?: any): void {
        if (prevProps.product != this.props.product) {
            let imgOptions: IComboBoxOption[] = [];
            let i=0;
            this.props.product.imageNames.split(',').forEach(imageName => {
                imgOptions.push({key: i, text: imageName});
                i++;
            });
            let tagOptions: IComboBoxOption[] = [];
            this.props.product.tags.split('|').forEach(tag => {
                const tagparts = tag.split("$:$");
                tagOptions.push({key: tagparts[0], text: tagparts[0], data: tagparts[1]});
            });
            this.setState({
                tagOptions:tagOptions,
                imgOptions:imgOptions,
                selectedImg: imgOptions.length ? imgOptions[0].text : "",
                rarityStyle: "",
                rarityImgStyle: "",
                selectedImageIdex: imgOptions.length ? imgOptions[0].key as number : 0,
                rarityImg: "",
                added: false,
                notAdded: false,
                startSwipe: -1,
                endSwipe: -1,
                selectedTagValue: "",
                selectedTagName: "",
                newTitle: this.props.product.title,
                newCost: this.calculatePriceWithoutCommission(this.props.product.priceInEUR),
                newTags: this.props.product.tags,
                newDescription: this.props.product.description,
                swipeHidden: this.props.hideSwipe,
                newAvailable: this.props.product.available,
                inputRef: React.createRef(),
                loading: false
            });
        }
    }

    componentDidMount(): void {
        if (this.props.hideSwipe === false) {
            this.swipeTimeout();
        }
    }

    calculatePrice = () : number => {
        let commission = (this.state.newCost/100)*this.props.commission;
        return Math.round((this.state.newCost+commission)*100)/100;
    }

    calculatePriceWithoutCommission = (price: number) : number => {
        const calc = 1+(this.props.commission/100);
        const nrp = price / calc
        return Math.round(nrp*100)/100;
    }

    swipeTimeout() {
        setTimeout(() => {
            this.setState({swipeHidden: true});
            setTimeout(() => {
                this.setState({swipeHidden: false});
                this.swipeTimeout();
            }, 60000);
        }, 2000);
    }

    canSave() : boolean {
        if (this.state.newTitle !== this.props.product.title) {
            return true;
        }
        if (this.calculatePrice() !== this.props.product.priceInEUR) {
            return true;
        }
        if (this.state.newTags !== this.props.product.tags) {
            return true;
        }
        if (this.state.newDescription !== this.props.product.description) {
            return true;
        }
        return false;
    }

    swipeEnd(e) {
        if (this.state.startSwipe != -1 && this.state.endSwipe != -1) {
            if ((this.state.endSwipe - this.state.startSwipe) > 20) {
                this.state.selectedImageIdex > 0 ? this.setState({selectedImageIdex : this.state.selectedImageIdex-1}) : this.setState({selectedImageIdex : this.props.product.imageUrls.length -1});
            } else if ((this.state.startSwipe - this.state.endSwipe) > 20) {
                this.state.selectedImageIdex+1 < this.props.product.imageUrls.length ? this.setState({selectedImageIdex : this.state.selectedImageIdex+1}) : this.setState({selectedImageIdex : 0});
            }
            this.setState({startSwipe: -1, endSwipe: -1});
        }
    }

    onSelectedImg(img : IComboBoxOption) {
        this.setState({ selectedImg: img.text, selectedImageIdex: img.key as number });
    }

    deleteImg() {
        this.setState({loading:true}, () => {
        //if (window.confirm("Are you sure you want to delete " + this.state.selectedImg)) {
            let formData = new FormData();

            formData.append("ImageName", this.state.selectedImg);    
            formData.append("sitename", this.props.selectedSite);    
            formData.append("SetID", this.props.product.setID.toString());            
            formData.append("Id", this.props.product.id.toString());
            formData.append("token", this.props.token);
            formData.append("username", this.props.username);
            formData.append("site", this.props.site);


            fetch(`${this.props.apiUrl}/removeProductimage`, {
                method: "Put",
                mode: "cors",
                referrerPolicy: "origin-when-cross-origin",
                body: formData
            }).then((response) => response.json()).then((data: boolean) => {
                if (data) {
                    this.props.reload();
                    this.props.setMessage(this.state.selectedImg+" successvol verwijderd");
                } else {
                    this.props.setError("Something went wrong in backend");
                }
            }).catch(err => {
                this.props.setError(err);
            });
        //}
        });
    }

    onNewImgSelected(files : FileList) {
        this.setState({loading:true}, 
            () => {
                let formData = new FormData();

                let addedNames : string[] = [];
                for (let j=0; j<files.length; j++) {
                    let youngest = 9999999999999;

                    for (let i=0; i<files.length; i++) {
                        if (addedNames.indexOf(files[i].name) === -1) {
                            if (files[i].lastModified < youngest) {
                                youngest = files[i].lastModified;
                            }
                        }
                    }

                    for (let i=0; i<files.length; i++) {
                        if (files[i].lastModified === youngest) {
                            formData.append(files[i].name, files[i]);
                            addedNames.push(files[i].name);
                        }
                    }
                }
                
                formData.append("sitename", this.props.selectedSite);
                formData.append("SetID", this.props.product.setID.toString());
                formData.append("Id", this.props.product.id.toString());
                formData.append("token", this.props.token);
                formData.append("username", this.props.username);
                formData.append("site", this.props.site);

                console.log(formData);

                fetch(`${this.props.apiUrl}/addProductImage`, {
                    method: "Put",
                    mode: "cors",
                    referrerPolicy: "origin-when-cross-origin",
                    body: formData
                }).then((response) => response.json()).then((data: boolean) => {
                    console.log(data);
                    if (data === false) {
                        this.props.setError("Something went wrong in backend");
                    }
                    this.props.reload();
                    this.props.setMessage("Foto's successvol toegevoegd");
                }).catch(err => {
                    this.props.setError(err);
                });
            }
        );
    }

    onTagValueChange(event,v) : void {
        let newTagValue = "";
        let found = false;
        this.props.product.tags.split('|').forEach(tag => {
            const tagparts = tag.split("$:$");
            if (tagparts[0] === this.state.selectedTagName) {
                found = true;
                newTagValue += tagparts[0] + "$:$" + v + "|";
            } else {
                newTagValue += tag + "|";
            }
        });
        if (!found) {
            newTagValue += this.state.selectedTagName + "$:$" + v;
        } else {
            newTagValue = newTagValue.substring(0,newTagValue.length-1);
        }

        let tagOptions: IComboBoxOption[] = [];
        newTagValue.split('|').forEach(tag => {
            const tagparts = tag.split("$:$");
            tagOptions.push({key: tagparts[0], text: tagparts[0], data: tagparts[1]});
        });

        this.setState({newTags:newTagValue, tagOptions: tagOptions, selectedTagValue: v});
    }

    onComboBoxChange(e,o) : void {
        if (this.state.tagOptions.filter(f => f.key === o.text).length === 1) {
            this.setState({selectedTagName: o.text, selectedTagValue: o.data});
        }
    }

    onAddTagClick(e) : void {
        if (this.state.newTagName.length > 0) {
            let tagOptions: IComboBoxOption[] = this.state.tagOptions;
            tagOptions.push({key: this.state.newTagName, text: this.state.newTagName, data: this.state.newTagValue});
            this.setState({tagOptions: tagOptions, 
                           newTags: this.state.newTags.length ? this.state.newTags+"|"+this.state.newTagName+"$:$"+this.state.newTagValue : this.state.newTagName+"$:$"+this.state.newTagValue,
                           selectedTagName: this.state.newTagName, 
                           selectedTagValue: this.state.newTagValue}, () => {
                this.setState({newTagName: "", 
                               newTagValue: ""});
            });
        }
    }

    onSaveClick() : void {
        this.setState({loading:true}, () => {
            let formData = new FormData();

            formData.append("Order", this.props.product.order ? this.props.product.order.toString() : "0");
            formData.append("sitename", this.props.selectedSite);
            formData.append("SetID", this.props.product.setID.toString());
            formData.append("Id", this.props.product.id.toString());
            formData.append("Available", this.state.newAvailable.toString());
            formData.append("Site", this.props.site);
            formData.append("token", this.props.token);
            formData.append("username", this.props.username);
            if (this.state.newDescription != this.props.product.description) {
                formData.append("Description", this.state.newDescription);
            } else {
                formData.append("Description", this.props.product.description);
            }
            if (this.state.newTitle != this.props.product.title) {
                formData.append("Title", this.state.newTitle);
            } else {
                formData.append("Title", this.props.product.title);
            }
            if ( this.calculatePrice() != this.props.product.priceInEUR) {
                formData.append("PriceInEUR", this.calculatePrice().toString());
            } else {
                formData.append("PriceInEUR", this.props.product.priceInEUR.toString());
            }
            if (this.state.newTags != this.props.product.tags) {
                formData.append("Tags", this.state.newTags);
            } else {
                formData.append("Tags", this.props.product.tags);
            }
           
            if (this.props.product.id !== 0) {
                fetch(`${this.props.apiUrl}/updateProduct`, {
                    method: "Put",
                    mode: "cors",
                    referrerPolicy: "origin-when-cross-origin",
                    body: formData
                }).then((response) => response.json()).then((data: boolean) => {
                    console.log(data);
                    if (data === false) {
                        this.props.setError("Something went wrong in backend");
                    }
                    this.props.reload();
                }).catch(err => {
                    this.props.setError(err);
                });
            } else {
                fetch(`${this.props.apiUrl}/addProduct`, {
                    method: "Put",
                    mode: "cors",
                    referrerPolicy: "origin-when-cross-origin",
                    body: formData
                }).then((response) => response.json()).then((data: boolean) => {
                    console.log(data);
                    if (data === false) {
                        this.props.setError("Something went wrong in backend");
                    } else {
                        this.props.setMessage("Successfully saved product");
                    }
                    this.props.reload(this.state.newTitle);
                }).catch(err => {
                    this.props.setError(err);
                });
            }
        });
    }

    onAddProductClick = () => {
        this.setState({newAvailable: this.state.newAvailable+1},
            () => {
                this.onSaveClick();
            }
        );
    }

    onRemoveProductClick = () => {
        if (this.state.newAvailable > 0) {
            this.setState({newAvailable: this.state.newAvailable-1},
                () => {
                    this.onSaveClick();
                }
            );
        }
    }

    public render(): React.ReactElement<IProductsProps> {
        const product = this.props.product;
        let shimmerStyle = "";
        if (this.props.animationsEnabled && product.rarety !== "Common" && product.rarety !== "Uncommon") {
            const r = Math.floor(Math.random() * 4);
            shimmerStyle = styles[`cardshimmer${r}`]
        }

        return (
            <Stack className={styles.card} style={{position:"relative"}}>
                {this.state.loading && <Stack verticalAlign='center' style={{position:"absolute",width:"100%",height:"100%",zIndex:2, backgroundColor:"rgba(0, 0, 0, 0.2)"}}><Spinner size={SpinnerSize.large} style={{zIndex:4}} label="Loading..." /></Stack>}
                <Stack>
                    <Stack horizontal verticalAlign='center' horizontalAlign='center' style={{overflow:"hidden"}}>
                        <div className={`${styles.cardshine} ${styles.cardCompImg}`}>
                            <Image {...{imageFit: ImageFit.centerContain,
                                        className: styles.cardCompImg,
                                        src: product.imageUrls[this.state.selectedImageIdex]?.replace('.jpeg','.webp').replace('.jpg','.webp').replace('.png','.webp'),
                                        styles: props => ({ root: { margin: 0, cursor: "pointer", backgroundColor: "transparent" } }),
                                    }} alt="" />
                            <div className={shimmerStyle}></div>
                        </div>
                    </Stack>
                    <Stack className={styles.cardInfo}>
                        <Stack horizontal horizontalAlign='center'>
                            {this.props.viewer ? <></> : <FontIcon iconName="Trash" className={styles.delete} onClick={this.deleteImg} />}
                            <ComboBox selectedKey={this.state.selectedImageIdex} options={this.state.imgOptions} onChange={(e, o) => { this.onSelectedImg(o); }} />
                            {this.props.viewer ? <></> : <FontIcon id="upload" iconName="Upload" className={styles.delete} onClick={() => { this.state.inputRef.current.click(); }} />}
                            {this.props.viewer ? <></> : <input id="upload" multiple type="file" hidden ref={this.state.inputRef} onChange={(e) => { this.onNewImgSelected(e.target.files); }}/>}
                        </Stack>
                        <hr/>
                        <div className={styles.divTable}>
                            <div className={styles.divTableRow}>
                                <div className={styles.divTableCell}>
                                    <Label>Title</Label>
                                </div>
                                <div className={styles.divTableCell}>
                                    <TextField disabled={this.props.viewer} title={`ID:${product.id} Title:${product.title}`} value={this.state.newTitle} onChange={(e,v) => { this.setState({newTitle: v}); }}/>
                                </div>
                            </div>
                            <div className={styles.divTableRow}>
                                <div className={styles.divTableCell}>
                                    <Label>EUR</Label>
                                </div>
                                <div className={styles.divTableCell}>
                                    <Stack horizontal verticalAlign='center'>
                                        <TextField disabled={this.props.viewer} type="number" step=".01" value={this.state.newCost?.toString()} onChange={(e,v) => { this.setState({newCost: Number(v.replace(',','.'))}); }} />
                                        <Label>{`+${this.props.commission}% €${this.calculatePrice()}`}</Label>
                                    </Stack>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div className={styles.divTable}>
                            <div className={styles.divTableRow}>
                                <div className={styles.divTableCell} style={{verticalAlign:"top"}}>
                                    <Label>Tags</Label>
                                </div>
                                <div className={styles.divTableCell}>
                                    <Stack horizontal horizontalAlign='end'>
                                        <ComboBox style={{width:120}} ref={this.state.tagRef} options={this.state.tagOptions} selectedKey={this.state.selectedTagName} onChange={this.onComboBoxChange.bind(this)} />
                                        <TextField disabled={this.props.viewer} style={{width:120}} value={this.state.selectedTagValue} onChange={this.onTagValueChange}/>
                                        {this.props.viewer ? <></> : <FontIcon iconName="Delete" className={styles.delete} onClick={()=>{alert("todo");}} />}
                                    </Stack>
                                    <Stack horizontal horizontalAlign='end'>
                                        <TextField disabled={this.props.viewer} style={{width:120}} value={this.state.newTagName} onChange={(e,v) => { this.setState({newTagName: v}); }}/>
                                        <TextField disabled={this.props.viewer} style={{width:120}}value={this.state.newTagValue} onChange={(e,v) => { this.setState({newTagValue: v}); }}/>
                                        {this.props.viewer ? <></> : <FontIcon iconName="Add" className={styles.delete} onClick={this.onAddTagClick.bind(this)} />}
                                    </Stack>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <Stack>
                            <TextField disabled={this.props.viewer} rows={5} multiline label='Description' value={this.state.newDescription} onChange={(e,v) => { this.setState({newDescription:v});}} />
                        </Stack>
                        <hr/>
                        <div className={styles.divTable}>
                            <div className={styles.divTableRow}>
                                <div className={styles.divTableCell}>
                                    &nbsp;
                                </div>
                                <div className={styles.divTableCell} style={{float:"right"}}>
                                    <PrimaryButton disabled={!this.canSave()} text='Save' onClick={() => { this.setState({loading: true}, () => { this.onSaveClick(); }); }}/>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <Stack horizontal horizontalAlign='space-between'>
                            <Stack horizontalAlign='start'>
                                {this.props.addCard == null ? 
                                    <Label><h2>Aantal : </h2></Label>
                                :
                                    <Label><b>Beschikbaar : </b></Label>}
                            </Stack>
                            <Stack horizontalAlign='start'>
                                {this.props.addCard == null ? 
                                        <Label><h2>{product.available}</h2></Label>
                                    :
                                        <Label><b>{product.available}</b></Label>}
                                
                            </Stack>
                        </Stack>
                        
                        {this.props.addCard != null && <Stack horizontal horizontalAlign='space-between'>
                            <PrimaryButton disabled={this.props.saving} text="-" onClick={this.onRemoveProductClick}/>
                            <PrimaryButton disabled={this.props.saving} text="+" onClick={this.onAddProductClick}/>
                        </Stack>}
                    </Stack>
                </Stack>
            </Stack> 
        );
    }
}